const GEOCODE_SKIP_BUFFER_MS = 100;

export type GeocodeSyncGuard = {
  isForwardGeocodeUpdate: boolean;
  isReverseGeocodeUpdate: boolean;
  markForwardGeocodePatch: () => void;
  markReverseGeocodePatch: () => void;
  beginReverseGeocodeRequest: () => number;
  isStaleReverseGeocodeRequest: (requestId: number) => boolean;
  dispose: () => void;
};

export function createGeocodeSyncGuard(debounceMs: number): GeocodeSyncGuard {
  let forwardSkipTimeout: ReturnType<typeof setTimeout> | undefined;
  let reverseSkipTimeout: ReturnType<typeof setTimeout> | undefined;
  let reverseGeocodeRequestId = 0;

  const guard: GeocodeSyncGuard = {
    isForwardGeocodeUpdate: false,
    isReverseGeocodeUpdate: false,
    markForwardGeocodePatch: () => {
      guard.isForwardGeocodeUpdate = true;
      clearTimeout(forwardSkipTimeout);
      forwardSkipTimeout = setTimeout(() => {
        guard.isForwardGeocodeUpdate = false;
        forwardSkipTimeout = undefined;
      }, debounceMs + GEOCODE_SKIP_BUFFER_MS);
    },
    markReverseGeocodePatch: () => {
      guard.isReverseGeocodeUpdate = true;
      clearTimeout(reverseSkipTimeout);
      reverseSkipTimeout = setTimeout(() => {
        guard.isReverseGeocodeUpdate = false;
        reverseSkipTimeout = undefined;
      }, debounceMs + GEOCODE_SKIP_BUFFER_MS);
    },
    beginReverseGeocodeRequest: () => ++reverseGeocodeRequestId,
    isStaleReverseGeocodeRequest: (requestId: number) => requestId !== reverseGeocodeRequestId,
    dispose: () => {
      clearTimeout(forwardSkipTimeout);
      clearTimeout(reverseSkipTimeout);
      forwardSkipTimeout = undefined;
      reverseSkipTimeout = undefined;
    },
  };

  return guard;
}
